const endpoints = {
    calllistanalytics: '/admin_api/call-list-analytics',
    //Admin dashboard
        GetDictationCount: 'admin_api/get-dictations-count',

    //-Provider
    FetchProvider: '/common_api/fetch-providers?practice_id=1&per_page=1000&status=active',
    UpdateProvider: '/admin_api/update-provider',
    CreateProvider: '/admin_api/create-provider',
    FetchSingleProvider: '/admin_api/fetch-single-provider',
    GetProviderDictation: 'assistant_api/get-provider-dictations',
    UpdateDictationStatus: 'assistant_api/update-dictation-status',
    UpdateDictationTask: 'assistant_api/update-dictation-tasks',
    FetchProviderAppCall: 'assistant_api/fetch-pending-appts-for-confirmation-call',
    SearchClaimStatusAnalytics: 'admin_api/appointments-claim-status-analytics',
    FetchAndUpdateTalkHrProvider: 'admin_api/fetch-and-update-talkeHr-providers',

    ManageProviderCases: 'admin_api/manage-provider-causes',
    practices: 'admin_api/practices',
    UpdatePractice: 'admin_api/update-practice',
    AddPractise: 'admin_api/add-practice',
    FetchAddress: 'common_api/fetch-addresses',
    GetAppoinments: 'common_api/fetch-appointments',
    searchpatient: 'common_api/search-patients',
    GetMedicalProgram: 'assistant_api/get-medical-programs',
    SCPForm: 'assistant_api/scp-forms',
    GetPatientByMedicalProgram: 'assistant_api/get-patients-by-medical-program',
    UpdatePatientByMedicalProgram: 'assistant_api/update-patient-medical-program',
    GetAllAssistant: 'admin_api/get-all-assistants',
    CreateAssistant: 'admin_api/create-assistant',
    UpdateAssistant: 'admin_api/update-assistant',
    GetCallList: 'assistant_api/call-list',
    FetchPromotionalVideo: 'promotional-videos/fetch',
    FetchAddressAdmin: 'admin_api/addresses',
    //-Patients------------//
    SavePatient: 'assistant_api/save-patient',
    UpdatePatient: 'assistant_api/update-patient',
    UpdatePatientBillDue: 'assistant_api/update-patient-bill-due',

    IssuancePayes: 'assistant_api/insurance-payers',
    locations: 'assistant_api/locations',
    GetDocuments: 'assistant_api/get-document',
    GetPatientDocs: 'assistant_api/get-patient-docs',
    //----Appointments-----------//
    AppointmentsStatus: 'assistant_api/appointment-statuses',
    AppointmentsForClaimsStatus: 'assistant_api/appointments-for-claim-status-update',
    UpdateAppointmentsClaimStatus: 'assistant_api/update-appointment-claim-status',
    Logout: 'assistant_api/logout'
};

export default endpoints;